var _rect, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddLead(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 102,
    height: 102,
    viewBox: "0 0 102 102",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 102,
    height: 102,
    rx: 50.77,
    fill: "#DEFAED"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M46.3296 50.0488C33.7891 50.0488 23.6702 59.8218 23.3242 72.2759C23.3242 72.7083 23.4972 73.2272 23.8431 73.5732C24.1891 73.9191 24.6215 74.0921 25.0539 74.0921H67.5188C67.9512 74.0921 68.4702 73.9191 68.7296 73.5732C69.0756 73.2272 69.2485 72.7948 69.2485 72.2759C68.9026 59.8218 58.7837 50.0488 46.3296 50.0488Z",
    fill: "#63686E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M46.3296 47.3682C51.6918 47.3682 56.1026 42.9574 56.1026 37.5952C56.1026 32.2331 51.6918 27.8223 46.3296 27.8223C40.9675 27.8223 36.5566 32.2331 36.5566 37.5952C36.5566 42.9574 40.9675 47.3682 46.3296 47.3682Z",
    fill: "#63686E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M76.9457 44.6881H70.8917V38.634C70.8917 37.6827 70.1133 36.9043 69.162 36.9043C68.2106 36.9043 67.4322 37.6827 67.4322 38.634V44.6881H61.3782C60.4268 44.6881 59.6484 45.4665 59.6484 46.4178C59.6484 47.3692 60.4268 48.1475 61.3782 48.1475H67.4322V54.2016C67.4322 55.1529 68.2106 55.9313 69.162 55.9313C70.1133 55.9313 70.8917 55.1529 70.8917 54.2016V48.1475H76.9457C77.8971 48.1475 78.6755 47.3692 78.6755 46.4178C78.6755 45.4665 77.8971 44.6881 76.9457 44.6881Z",
    fill: "#87D4AF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddLead);
export default __webpack_public_path__ + "static/media/add-lead.a3ccec105870398971aebea18ce36bc1.svg";
export { ForwardRef as ReactComponent };